module.exports = __webpack_public_path__ + "static/menu-planner-ed6786189c183cde5ad60dfd711ca27f.mp4";